/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\CarCost.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Monday, February 13th 2023, 5:00:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const CarCostBg = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
display: flex;
border-radius: 5px;
background-color: ${(props: any) => getThemeColor(props.bgColor)};
transition: 0.3s ease;
`;

export default CarCostBg;
